
<div  style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x" [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu #contextMenu="matMenu">
	<ng-template matMenuContent let-item="item">
		<button mat-menu-item (click)="editChatOffer(item)">
			<mat-icon svgIcon="edit_alt"></mat-icon>
			<span>{{ 'tabot.edit_offer' | translate }}</span>
		</button>
		<button mat-menu-item (click)="deleteChatOffer(item)">
			<mat-icon svgIcon="trash"></mat-icon>
			<span>{{ 'tabot.delete_offer' | translate }}</span>
		</button>
	</ng-template>
</mat-menu>


<div class="chat-container" [dir]="appService.direction">
    <div class="chat-header branding-color-4 branding-background-3">
        <div class="tabot-ai-container">
            <mat-icon class="_icon" svgIcon="tabot-ai" aria-label="tabot ai"></mat-icon>
        </div>

		<div>
			<button mat-icon-button color="accent" [matMenuTriggerFor]="textSizeMenu">
				<mat-icon svgIcon="text-size" class="rotate-ltr"></mat-icon>
			</button>
			<mat-menu #textSizeMenu="matMenu" >
				<h6 class="dropdown-header">{{ 'tabot.text_size' | translate }}</h6>
				@for (size of textSizes; track size) {
					<button mat-menu-item (click)="setTextSize(size)" [class.active]="size === currentTextSize()">
						<!--<mat-icon svgIcon="text-size" class="rotate-ltr"></mat-icon>-->
						<span>{{floor(size * 100)}}%</span>
					</button>
				}
			</mat-menu>
		</div>
        <h2>{{ 'tabot.mobile_header_title' | translate }}</h2>
		@if (appService.regionArgs.translations) {
			<button mat-icon-button color="accent" (click)="toggleTranslation()">
				<mat-icon svgIcon="globe"></mat-icon>
			</button>
		}
		<button mat-icon-button color="accent" (click)="close()" style="padding: 9px;">
			&#10005;
		</button>

    </div>

    <div class="chat-messages" [ngStyle]="{'font-size':(currentTextSize() + 'rem')}" #scrollContainer >
        @for (msg of validMessages; track msg; let last = $last) {
			<div class="message" [class.last]="last" [ngClass]="msg.role" [dir]="msg.direction" #markdownContainers>
				<markdown [data]="msg.content || ''"></markdown>
			</div>
        }
        @if (showResetConfirmation()) {
        <div class="message assistant confirmation-message">
            <div class="confirmation-content">
                <div class="confirmation-text">
                    {{ 'tabot.confirm_reset_message' | translate }}
                </div>
                <div class="confirmation-buttons">
                    <button type="button" class="confirm-btn branding-color-12 branding-background-11"
                        (click)="confirmResetChat()">
                        {{ 'tabot.confirm_reset_yes' | translate }}
                    </button>
                    <button type="button" class="cancel-btn branding-color-4 branding-background-3"
                        (click)="cancelResetChat()">
						{{ 'tabot.confirm_reset_no' | translate }}
                    </button>
                </div>
            </div>
        </div>
        }

        @if (loading()) {
        <div class="chat-spinner-message">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
        }
    </div>

    <div class="form-container">
        <form class="chat-form-container" (submit)="sendMessage(); $event.preventDefault()">
            <div class="chat-form">
                <textarea #chatInput [ngModel]="prompt()" (ngModelChange)="prompt.set($event); adjustTextareaHeight()"
                    name="chatInput" [placeholder]="'tabot.input_placeholder' | translate" autocomplete="off" rows="1"
                    (keydown)="onTextareaKeydown($event)">
				</textarea>

				@if (!loading()) {
					<button class="action-button" type="submit"
						[disabled]="loading() || showResetConfirmation()">
						<mat-icon class="chat-arrow" svgIcon="chat-arrow" aria-hidden="true"></mat-icon>
					</button>
				}
				@if (loading()) {
					<button type="button" class="action-button"
						(click)="cancelOngoingRequest()">
						<mat-icon svgIcon="chat-square" aria-hidden="true"></mat-icon>
					</button>
				}

            </div>
        </form>

        <div class="action-buttons">
			@if (hasMessages()) {
				<button type="button" class="action-button" (click)="resetChat()" [disabled]="loading()">
					<mat-icon svgIcon="reload" aria-hidden="true"></mat-icon>
				</button>
			}
			<app-audio-recorder
				[buttonSize]="'small'"
				[sessionId]="sessionId"
				(transcriptionComplete)="handleTranscriptionComplete($event)"
				(transcriptionError)="handleTranscriptionError($event)"
				[disabled]="loading() || showResetConfirmation()"
				>
			</app-audio-recorder>
			<div style="flex-grow: 1"></div>

			<button type="button" class="rounded" style="height: 40px" mat-flat-button color="accent" (click)="getChatOffersAndAddToBasket()" [disabled]="loading() || showResetConfirmation() || !enableSyncBasket()">
				<div class="d-flex align-items-center" style="gap:5px">
					<mat-icon class="sm" svgIcon="shopping-cart" aria-hidden="true"></mat-icon>
					<span>{{ 'tabot.sync_basket' | translate }}</span>
				</div>
			</button>

        </div>
    </div>
</div>


